import React from "react";
import { Box, Text } from "@chakra-ui/react";
import ActivityRemixModalContainer from "./ActivityRemixModalContainer";

/**
 * InsightModal - Displays AI-generated insights about why an activity was chosen
 * Shows the insight in a styled container with lightbulb icon and provides options
 * to refine the activity or skip the insight.
 */
const InsightModal = ({
  isOpen,
  onClose,
  insight,
  onRefineActivity,
  onSkip,
  isRefining = false,
}) => {
  return (
    <ActivityRemixModalContainer
      isOpen={isOpen}
      onClose={onClose}
      title="Smart Agenda Insight"
      primaryButtonTitle="✨ Let's Refine this Activity"
      secondaryButtonTitle="Skip for now"
      onPrimaryClick={onRefineActivity}
      onSecondaryClick={onSkip}
      isPrimaryLoading={isRefining}
      primaryLoadingText="Refining..."
      primaryButtonTestId="refine-activity-button"
      secondaryButtonTestId="skip-insight-button"
    >
      {/* Insight Content with Lightbulb Icon */}
      <Box
        bg="#EDEDFA"
        borderRadius="12px"
        p={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={2}
      >
        {/* Icon Group */}
        <Box position="relative" width="24px" height="24px" flexShrink={0}>
          {/* Background Circle */}
          <Box
            position="absolute"
            top={0}
            left={0}
            width="24px"
            height="24px"
            borderRadius="50%"
            bg="transparent"
          />
          {/* Lightbulb Icon */}
          <Box
            position="absolute"
            top="2px"
            left="2px"
            width="20px"
            height="20px"
            color="#F79009"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="16px"
          >
            💡
          </Box>
        </Box>

        {/* Insight Text */}
        <Text
          fontFamily="Geist, sans-serif"
          fontWeight="400"
          fontSize="14px"
          lineHeight="1.43"
          letterSpacing="-0.02em"
          color="#433358"
          textAlign="left"
          flex={1}
        >
          Insight: {insight}
        </Text>
      </Box>
    </ActivityRemixModalContainer>
  );
};

export default InsightModal;
